import { create } from 'zustand';
import { conditionalDevtools } from '@/lib/storeMiddleware';
import type { Email } from '@/types/email';

interface LinkedEmailViewerState {
  open: boolean;
  email: Email | null;
  openViewer: (email: Email) => void;
  closeViewer: () => void;
}

export const useLinkedEmailViewerStore = create<LinkedEmailViewerState>()(
  conditionalDevtools(
    (set) => ({
      open: false,
      email: null,
      openViewer: (email) => set({ open: true, email }),
      closeViewer: () => set({ open: false, email: null }),
    }),
    { name: 'LinkedEmailViewerStore' }
  )
);
